export const GET = 'get'
export const POST = 'post'
export const PATCH = 'patch'
export const DELETE = 'delete'
export const CONFIRMED = 'confirmed'
export const CANCELED = 'canceled'
